import { apiSlice } from 'src/features/api/api-slice';
import { RTKQueryTag } from 'src/common/constants';
import { ApiResponse } from 'src/common/interfaces';

import { SkillsMatrixParams } from './share-skills-modal.types';

export const skillsMatrixApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSkillsMatrixImage: builder.query<ApiResponse<string>, SkillsMatrixParams>({
      query: ({ role, segment }) => `users/skills/generate-image/?role=${role}&segment=${segment}`,
      providesTags: [RTKQueryTag.SkillsMatrixImage],
    }),
  }),
});

export const { useGetSkillsMatrixImageQuery } = skillsMatrixApiSlice;
